const merchList = [
    {
        name: 'T-shirt',
        img: 'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=80',
        price: '8.90',
        id: '123',
        rating: 4,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'tshirt',
    },
    {
        name: 'Ponjo',
        img: 'https://images.unsplash.com/photo-1434389677669-e08b4cac3105?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
        price: '15.45',
        id: '124',
        rating: 3,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'accessory',
    },
    {
        name: 'Long Coat',
        img: 'https://images.unsplash.com/photo-1539533018447-63fcce2678e3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=334&q=80',
        price: '69.99',
        id: '125',
        rating: 5,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'winter',
    },
    {
        name: 'Black T-shirt',
        img: 'https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=334&q=80',
        price: '10',
        id: '126',
        rating: 2,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'tshirt',
    },
    {
        name: 'T-shirt original',
        img: 'https://images.unsplash.com/photo-1576566588028-4147f3842f27?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60',
        price: '11.80',
        id: '127',
        rating: 1,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'tshirt',
    },
    {
        name: 'Shorts',
        img: 'https://images.unsplash.com/photo-1591195853828-11db59a44f6b?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80',
        price: '9.80',
        id: '128',
        rating: 3,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'short',
    },
    {
        name: 'Nike air',
        img: 'https://images.unsplash.com/photo-1549298916-b41d501d3772?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1000&q=80',
        price: '87.50',
        id: '129',
        rating: 5,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'shoes',
    },
    {
        name: 'Purse',
        img: 'https://images.unsplash.com/photo-1594223515488-7dbc35d61eca?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=694&q=80',
        price: '70.00',
        id: '130',
        rating: 4,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'accessory',
    },
    {
        name: 'Glasses',
        img: 'https://images.unsplash.com/photo-1586051384951-bb5e7d1a5e57?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80',
        price: '24.50',
        id: '131',
        rating: 3,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'accessory',
    },
    {
        name: 'Short Coat',
        img: 'https://images.unsplash.com/photo-1575862980084-cd0645edddba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80',
        price: '79.90',
        id: '132',
        rating: 5,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'winter',
    },
    {
        name: 'Beach Hat',
        img: 'https://images.unsplash.com/photo-1591178516464-be524c9b1666?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80',
        price: '3.99',
        id: '133',
        rating: 2,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'accessory',
    },
    {
        name: 'Brown Long Coat',
        img: 'https://images.unsplash.com/photo-1580314030455-1d182ab1f4f2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=633&q=80',
        price: '79.90',
        id: '134',
        rating: 5,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat, maiores.',
        category: 'winter',
    },
];

export default merchList;
